import { endOfDay, format, isEqual, startOfDay } from 'date-fns';

/**
 * Formats a date range for timeslot queries.
 * Pure function: `now` must be injected by the caller to avoid instability.
 * @param date - The selected date
 * @param now - The current instant (caller responsibility)
 * @returns An object with formatted dateFrom and dateTo strings
 */
export const formatTimeslotDateRange = (date: Date, now: Date) => {
  const today = startOfDay(now);
  let dateFrom = startOfDay(date);
  if (isEqual(dateFrom, today)) {
    dateFrom = new Date(now);
    dateFrom.setSeconds(0, 0);
  }

  return {
    dateFrom: format(dateFrom, "yyyy-MM-dd'T'HH:mm:ss"),
    dateTo: format(endOfDay(date), "yyyy-MM-dd'T'HH:mm:ss"),
  };
};
